export default class Storage {
  constructor({
    namespace,
    provider,
    serialize = JSON.stringify,
    deserialize = JSON.parse,
  }) {
    this.namespace = namespace;
    this.provider = provider;
    this.serialize = serialize;
    this.deserialize = deserialize;
  }

  getItem(k) {
    const key = this.createKey(k);
    const data = this.provider.getItem(key);
    if (!data) return;
    const { value, expires } = this.deserialize(data);
    if (expires === 0 || expires > Date.now()) {
      return this.deserialize(value);
    } else {
      this.removeItem(k);
    }
  }

  setItem(k, val, exp = 0) {
    const key = this.createKey(k);
    const data = {
      value: this.serialize(val),
      expires: exp ? exp + Date.now() : exp,
    };
    this.provider.setItem(key, this.serialize(data));
  }

  removeItem(k) {
    if (k) {
      const key = this.createKey(k);
      this.provider.removeItem(key);
    }
  }

  clear() {
    let index = 0;
    const removeKeys = [];
    while (index > -1) {
      const key = this.provider.key(index);
      if (key) {
        if (key.indexOf(this.namespace) !== -1) {
          removeKeys.push(key);
        }
        index++;
      } else {
        index = -1;
      }
    }
    removeKeys.forEach((key) => {
      this.provider.removeItem(key);
    });
  }

  createKey(k) {
    return `${this.namespace}_${k}`;
  }
}

export const localStorage = new Storage({
  namespace: 'UNION_LOCAL',
  provider: window.localStorage,
});

export const sessionStorage = new Storage({
  namespace: 'UNION_SESSION',
  provider: window.localStorage,
});
